import { useEffect, useRef } from 'react';

export default function PhilosophyCta() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .scale-in').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="floating-cta-hide" ref={sectionRef} className="py-20 px-6" style={{ backgroundColor: '#3E5F8F' }}>
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-normal text-white mb-8 fade-up" style={{ fontFamily: 'Noto Serif JP, serif' }}>
          治療を始めるための予約ではありません。<br />
          あなたが判断できる状態になるための相談です。
        </h2>
        <div className="scale-in">
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all duration-300 hover:scale-105 mb-8 whitespace-nowrap cursor-pointer"
            style={{ color: '#3E5F8F' }}
          >
            <span>無料診断を予約する(レポート作成)</span>
            <i className="ri-arrow-right-line text-2xl" />
          </a>
        </div>
        <div className="space-y-2 text-sm text-white fade-up">
          <p>※ 初回相談・診査・判断整理レポート作成は無料です</p>
          <p>※ その場で結論を出す必要はありません</p>
          <p>※ 他院と比較するための相談でも問題ありません</p>
        </div>
      </div>
    </section>
  );
}